import { Component, computed, effect, inject, input, output } from '@angular/core';
import { Select, Button } from 'excellence-ui';
import { PRICE_DATA_MIN_DATE } from '../analysis-price-filters/definitions';
import { PriceCurveState, PriceFilter, PriceStore } from '../../stores/price.store';
import { setYear } from 'date-fns';

import { TranslocoPipe } from '@jsverse/transloco';
@Component({
  imports: [Select, TranslocoPipe, Button],
  selector: 'app-analysis-price-comparison-select',
  templateUrl: './analysis-price-comparison-select.html',
})
export class AnalysisPriceComparisonSelect {
  private priceStore = inject(PriceStore);

  currentFilter = input.required<PriceFilter>();
  protected selectedYear = computed(() => this.currentFilter().compareHistoricYear);
  private granularity = computed(() => this.currentFilter().granularity);

  selectChange = output<string | null>();

  protected historicYears = computed(() => {
    const minYear = PRICE_DATA_MIN_DATE.getFullYear();
    const currentYear = new Date().getFullYear();
    const years: { year: number; state: PriceCurveState | null }[] = [];
    for (let year = currentYear - 1; year >= minYear; year--) {
      const state = this.priceStore.get({
        ...this.currentFilter(),
        date: setYear(this.currentFilter().date, year),
        granularity: this.granularity(),
      });
      years.push({ year, state });
    }
    return years;
  });

  constructor() {
    effect(() => this.loadHistoric(this.granularity(), this.currentFilter().date));
  }

  private loadHistoric(granularity: PriceFilter['granularity'], date: Date) {
    const minYear = PRICE_DATA_MIN_DATE.getFullYear();
    const currentYear = new Date().getFullYear();
    for (let year = currentYear - 1; year >= minYear; year--) {
      const historicFilter: PriceFilter = {
        ...this.currentFilter(),
        date: setYear(date, year),
        granularity,
      };
      if (!this.priceStore.get(historicFilter)) {
        this.priceStore.queue(historicFilter);
      }
    }
  }
}
